
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMunicipality } from "../../redux/actions/municipalitiesActions";
import { fetchDistricts } from "../../redux/actions/locationActions";
import toast from "react-hot-toast";

const CreateMunicipality = () => {
  const dispatch = useDispatch();

  const {
    createLoading,
    createSuccess,
    createError,
  } = useSelector((state) => state.municipalities || {});
  const { districts } = useSelector((state) => state.location || {});

  const [name, setName] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [status, setStatus] = useState("active");

  useEffect(() => {
    dispatch(fetchDistricts());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !districtId) {
      toast.error("All fields are required.");
      return;
    }
    dispatch(createMunicipality({ name, district_id: Number(districtId), status }));
  };

  useEffect(() => {
    if (createSuccess) {
      toast.success("Municipality created successfully!");
      setName("");
      setDistrictId("");
      setStatus("active");
    } else if (createError) {
      const message =
        createError?.meta?.message || "Failed to create municipality";
      toast.error(message);
    }
  }, [createSuccess, createError]);

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Municipality</h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Municipality Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter municipality name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">
              District <span className="text-red-500">*</span>
            </label>
            <select
              value={districtId}
              onChange={(e) => setDistrictId(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            >
              <option value="">-- Select District --</option>
              {districts?.map((dist) => (
                <option key={dist.id} value={dist.id}>
                  {dist.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <button
            type="submit"
            disabled={createLoading}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              createLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {createLoading ? "Creating..." : "Create Municipality"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateMunicipality;
